import ScoreByAnswerToOtherQuestionBarChart from './ScoreByAnswerToOtherQuestionBarChart';
export default ScoreByAnswerToOtherQuestionBarChart;



// WEBPACK FOOTER //
// ./src/components/ScoreByAnswerToOtherQuestionBarChart/index.js